import { render } from "./news.vue?vue&type=template&id=325c1f84&ts=true"
import script from "./news.vue?vue&type=script&lang=ts&config=true"
export * from "./news.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__